import { render, staticRenderFns } from "./card-style.vue?vue&type=template&id=3cf24825"
import script from "./card-style.vue?vue&type=script&lang=js"
export * from "./card-style.vue?vue&type=script&lang=js"
import style0 from "./card-style.vue?vue&type=style&index=0&id=3cf24825&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports